import { CrewMemberExt, PersonaMessages } from '@bechtel/client-common';
import { CrewMember, PersonaType } from '@bechtel/types';
import { useLingui } from '@lingui/react';

interface CrewMemberUtil {
  getCrewMemberExt: (crewMember: CrewMember) => CrewMemberExt;
}

export function useCrewMember(): CrewMemberUtil {
  const { i18n } = useLingui();
  const getCrewMemberExt = (crewMember: CrewMember): CrewMemberExt => {
    if (crewMember?.persona === PersonaType.FOREMAN)
      return {
        ...crewMember,
        title: crewMember?.crew?.crewNumber
        ? i18n._(PersonaMessages[crewMember?.persona]).concat(', ', `${crewMember?.crew?.crewNumber}`)
          : i18n._(PersonaMessages[crewMember?.persona]),
      };
    else if (crewMember?.persona === PersonaType.GENERAL_FOREMAN || crewMember?.persona === PersonaType.SUPERINTENDENT)
      return { ...crewMember, title: i18n._(PersonaMessages[crewMember?.persona]) };
    else return { ...crewMember, title: crewMember?.subGroupDescription ? crewMember?.subGroupDescription : '' };
  };
  return { getCrewMemberExt };
}
